<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <h2 class="text-2xl font-bold mb-0 text-blue-600">
          📅 Geplanter Kontrolltermin
        </h2>
      </div>
    </div>

    <!-- Status Description -->
    <div class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded">
      <div class="flex">
        <div class="flex-shrink-0">
          <mat-icon class="text-blue-400">schedule</mat-icon>
        </div>
        <div class="ml-3">
          <p class="text-sm text-blue-700">
            Dieser Kontrolltermin ist geplant und kann aktiviert werden.
          </p>
        </div>
      </div>
    </div>

    <!-- Header Info Section -->
    <app-header-info 
      [kontrolltermin]="kontrolltermin" 
      [editableFields]="[]"
      [showTimeFields]="true"
      [sourceStatus]="'geplant'"
      (batchFieldsChanged)="onHeaderBatchChanged($event)">
    </app-header-info>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Techniker...</span>
    </div>

    <!-- Content -->
    <div *ngIf="!isLoading" class="space-y-4">

    </div>

    <!-- Missing Objekt-Struktur Warning -->
    <div *ngIf="hasActiveObjektStruktur === false"
         class="mb-6 p-4 bg-amber-50 border-l-4 border-amber-400 rounded">
      <div class="flex">
        <div class="flex-shrink-0">
          <mat-icon class="text-amber-500">warning</mat-icon>
        </div>
        <div class="ml-3">
          <p class="text-sm text-amber-800 font-medium mb-1">
            Für diesen Standort ist noch keine Objekt-Struktur vorhanden.
          </p>
          <p class="text-sm text-amber-700 mb-3">
            Ohne Gebäude, Sektion und Raum mit Indikatoren kann der Auftrag nicht aktiviert werden.
            Legen Sie schnell eine Standardstruktur an und ergänzen Sie anschließend die Indikatoren.
          </p>
          <div class="flex flex-wrap gap-3">
            <button mat-raised-button color="primary"
                    [disabled]="isCreatingDefaultStruktur"
                    (click)="createDefaultObjektStruktur()">
              <mat-icon class="mr-2">auto_awesome</mat-icon>
              Standard-Objektstruktur anlegen
            </button>
            <button mat-stroked-button (click)="goToObjektStruktur()">
              <mat-icon class="mr-2">open_in_new</mat-icon>
              Objekt-Struktur bearbeiten
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions Section -->
    <div class="flex justify-between items-center pt-6 border-t border-gray-200">
      <!-- Delete button on the left -->
      <button 
        (click)="onDelete()" 
        mat-button
        color="warn"
        class="text-red-600 hover:text-red-800 hover:bg-red-50">
        <mat-icon class="mr-2 w-5 h-5">delete</mat-icon>
        Löschen
      </button>
      
      <!-- Other actions on the right -->
      <div class="flex space-x-4">
        <button 
          (click)="onCancel()" 
          mat-button>
          Abbrechen
        </button>
        
        <button 
          (click)="onSave()" 
          [disabled]="!selectedTechnikerId || isSaving" 
          mat-raised-button 
          color="primary">
          <span *ngIf="isSaving">Wird gespeichert...</span>
          <span *ngIf="!isSaving">Speichern</span>
        </button>
        
        <button 
          (click)="activateKontrolltermin()" 
          [disabled]="!selectedTechnikerId || isSaving" 
          mat-raised-button 
          color="accent">
          <span *ngIf="isSaving">Wird aktiviert...</span>
          <span *ngIf="!isSaving">Aktivieren</span>
        </button>
      </div>
    </div>
  </div>
</div>
